import {
  ContestBudgetRange,
  ContestEntryOffer,
  ContestViewContest,
} from '@freelancer/datastore/collections';

export enum PreviewModalResponse {
  AWARD,
  BUY,
  START_CHAT,
  REPORT,
  MAKE_OFFER,
}

export interface PreviewModalDetails {
  readonly contest: ContestViewContest;
  readonly imageSliderIndex: number;
  readonly isContestOwner: boolean;
  readonly hasContestAwardedEntry: boolean;
  readonly initialEntryId: number;
  readonly entryIds?: ReadonlyArray<number>;
  readonly isOnMultiAward: boolean;
  readonly canMultiAward: boolean;
  readonly contestBudgetRange: ContestBudgetRange;
  readonly currentOffer?: ContestEntryOffer;
}
